import React, { useEffect, useState } from "react";
import { SimpleGrid, Icon } from "@chakra-ui/react";
import { Stat, StatLabel, StatNumber } from "@chakra-ui/react";
import { FaCalendarAlt, FaRuler, FaClock, FaListOl, FaRoad, FaRunning, FaBolt } from "react-icons/fa";

const cardData = [
  { key: "time_training", label: "Days training", unit: "days", icon: FaCalendarAlt },
  { key: "total_km", label: "Total km", unit: "km", icon: FaRuler },
  { key: "total_time", label: "Total hours", unit: "hours", icon: FaClock },
  { key: "total_runs", label: "Total runs", unit: "", icon: FaListOl },
  { key: "max_distance", label: "Max distance", unit: "km", icon: FaRoad },
  { key: "max_run_distance", label: "Max running distance", unit: "km", icon: FaRunning },
  { key: "sum_power", label: "Total Power", unit: "KW", icon: FaBolt },
];

function SummaryCards() {
  const [summary, setSummary] = useState({});

  useEffect(() => {
    fetch("/data/summary.json")
      .then(res => res.json())
      .then(data => {
        setSummary(data);
        console.log("Summary loaded:", data); // Print after summary is loaded
      });
  }, []);

  // Helper to round numbers to 1 digit
  const formatValue = (value) => {
    if (typeof value === "number") {
      return Math.round(value * 10) / 10;
    }
    return value;
  };

  return (
    <SimpleGrid columns={[1, 2, 3, 4]} spacing={6}>
      {cardData.map(card => (
        <Stat key={card.key} p={4} shadow="md" borderRadius="md" bg="orange.50">
          <Icon as={card.icon} boxSize={6} color="orange.400" mb={2} />
          <StatLabel>{card.label}</StatLabel>
          <StatNumber>
            {formatValue(summary[card.key])} {card.unit}
          </StatNumber>
        </Stat>
      ))}
    </SimpleGrid>
  );
}

export default SummaryCards;